module.exports = __webpack_public_path__ + "media/images/svg/instagram-571351ef208ab5f2421331777f18149e.svg";